import { Assessments } from "../models/Assessments";
import { Assessment } from "../models/Assessment";
import { AssessmentPayload } from "../models/AssessmentPayload";
import { baseUrl, headers } from "./config";
import { fetchAndParse, addQueryParameter } from "./utils";
export function getApiAssessmentList(params?: {
    skip?: number;
    limit?: number;
    search?: string;
    sortBy?: string;
    sortOrder?: "asc" | "desc";
}): Promise<Assessments> {
    const url = new URL(`/api/assessment/list`, baseUrl);
    addQueryParameter(url, "skip", params?.skip);
    addQueryParameter(url, "limit", params?.limit);
    addQueryParameter(url, "search", params?.search);
    addQueryParameter(url, "sortBy", params?.sortBy);
    addQueryParameter(url, "sortOrder", params?.sortOrder);
    return fetchAndParse<Assessments>(url.toString(), { method: "GET", headers });
}
export function getApiAssessmentAssessmentid(assessmentId: number): Promise<Assessment> {
    const url = new URL(`/api/assessment/${assessmentId}`, baseUrl);
    return fetchAndParse<Assessment>(url.toString(), { method: "GET", headers });
}
export function putApiAssessmentAssessmentid(assessmentId: number, body?: AssessmentPayload): Promise<Assessment> {
    const url = new URL(`/api/assessment/${assessmentId}`, baseUrl);
    return fetchAndParse<Assessment>(url.toString(), { method: "PUT", body: JSON.stringify(body), headers });
}
export function deleteApiAssessmentAssessmentid(assessmentId: number): Promise<boolean> {
    const url = new URL(`/api/assessment/${assessmentId}`, baseUrl);
    return fetchAndParse<boolean>(url.toString(), { method: "DELETE", headers });
}
export function postApiAssessment(body?: AssessmentPayload): Promise<Assessment> {
    const url = new URL(`/api/assessment`, baseUrl);
    return fetchAndParse<Assessment>(url.toString(), { method: "POST", body: JSON.stringify(body), headers });
}
